export default "__VITE_ASSET__BHii1aIq__"